// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2CnD0","delete":"styles_delete__27K0N","update":"styles_update__206j3","add":"styles_add__E9pnj"};